<template>
  <div class="room">
    <div class="room-container">
      <div class="room-container__left">
        <div class="room-host-about">
          <div class="host-avatar">
            <img v-lazy="avatar" width="100%" alt="avatar" />
          </div>

          <div class="host-center">
            <div class="host-nickname">
              {{ videoInfo.nickname }}
            </div>

            <div class="host-info" :data-room-status="videoInfo.roomStatus">
              <div class="info-bigoId">BIGO ID:{{ bigoid }}</div>
              <!-- <i class="line">|</i> -->
              <client-only>
                <div class="info-bean">{{ videoInfo.bean }}</div>
                <div class="info-view-nums">{{ nums }}</div>
                <div class="info-location">{{ liveInfo.country_code }}</div>
              </client-only>
            </div>
          </div>

          <div class="host-right">
            <transition name="poptip-animation">
              <div v-if="showPoptip" class="poptip poptip-dom">
                <a
                  target="_blank"
                  class="share-link share-WhatsApp"
                  href="javascript:;"
                  @click="shareClick('whatsApp')"
                >
                  Share to WhatsApp
                </a>

                <a
                  target="_blank"
                  class="share-link share-Twitter"
                  href="javascript:;"
                  @click="shareClick('twitter')"
                >
                  Share to Twitter
                </a>

                <a
                  target="_blank"
                  class="share-link share-Pinterest"
                  href="javascript:;"
                  @click="shareClick('pinterest')"
                >
                  Share to Pinterest
                </a>

                <a
                  target="_blank"
                  class="share-link share-Reddit"
                  href="javascript:;"
                  @click="shareClick('reddit')"
                >
                  Share to Reddit
                </a>

                <a
                  target="_blank"
                  class="share-link share-Facebook"
                  href="javascript:;"
                  @click="shareClick('facebook')"
                >
                  Share to Facebook
                </a>

                <a
                  class="share-link share-Copy copylink_btn"
                  href="javascript:;"
                  :data-clipboard-text="clipboardVal"
                  @click="shareClick('copy')"
                >
                  Copy link
                </a>
              </div>
            </transition>

            <div
              v-if="!myBigoId || (myBigoId && myBigoId !== bigoid)"
              class="host-follow"
            >
              <div
                :class="['host-follow-btn', { followed: isFollowed }]"
                @click="follow"
              >
                {{ isFollowed ? 'Following' : $t('lang014') }}
              </div>
              <div v-show="showFollowSuccess" class="host-follow-success"></div>
              <div v-show="showUnfollowTips" class="host-unfollow-tips">
                <a
                  href="/index_wap.html"
                  class="host-unfollow-link"
                  target="_blank"
                >
                  Download
                </a>
              </div>
              <div v-if="showFollowGuide" class="follow_guide">
                <p
                  class="follow_guide_btn"
                  @click="showFollowGuide = false"
                ></p>
              </div>
            </div>

            <div
              :class="['host-share-btn', 'poptip-dom']"
              @click="showPoptip = !showPoptip"
            >
              {{ $t('lang095') }}
            </div>

            <div class="guide-phone">
              <div class="guide-phone-title">
                {{ $t('lang019') }}
              </div>

              <div class="scan-qr-code">
                <div class="scan-qr-code-desc">
                  {{ $t('lang174') }}
                </div>
                <div class="scan-qr-code-steps">
                  <table>
                    <tbody>
                      <tr>
                        <td width="180">
                          <p class="step step-title">
                            {{ $t('lang175') }} <br />{{ $t('lang176') }}
                          </p>
                        </td>
                        <td width="167">
                          <p class="step step-title">
                            {{ $t('lang177') }}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <img
                            class="mt10"
                            :src="require('~/assets/img/open-code.png')"
                          />
                        </td>
                        <td>
                          <!-- 生成二维码 -->
                          <div class="qr-code-box mt10"></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="room-video">
          <Player
            ref="player"
            :current="current"
            show-danmu-btn
            in-room
            @finishInitLive="finishInitLive"
            @endLive="endLive"
            @multiPersonClick="handleOpenMultiCover"
          ></Player>

          <div v-show="showPKCover" class="pk_live_box">
            <button class="close_btn" @click="showPKCover = false"></button>
            <div class="multi_live_cont">
              <div class="multi_live_tips">
                {{ videoInfo.nickname }} is in
                {{
                  liveInfo.roomStatus === 4 ? 'Multi-person room' : 'PK mode'
                }}
                on BIGO LIVE App <br />Scan the QR code to watch or start PK
              </div>
              <div class="multi_live_code">
                <div class="code_box"></div>
              </div>
              <div class="multi_live_download">
                <span>Don't have bigo live app?</span>
                <a href="/bigo_intro.html">Download</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="room-container__right">
        <Chat :data="chatData"></Chat>

        <div class="user_sent_msg">
          <div class="user_words_msg">
            <textarea
              v-model="comment"
              placeholder="chat with everyone"
              @keyup.enter.prevent="send"
            ></textarea>

            <div v-if="!isLogin" class="login_tips">
              <a @click="loginPopUpVisible = true">Login</a> to chat with
              everyone
            </div>
            <a class="send_btn" href="javascript:;" @click="send">
              Send
            </a>
          </div>
        </div>
      </div>
    </div>

    <DisCordBanner isRoom />

    <div class="room-recommend-live clearfix">
      <div class="room-recommend-live__header clearfix">
        <h6 class="header-title">
          {{ $t('lang052') }}
        </h6>

        <div class="header-right">
          <div
            class="header-change"
            :class="{ 'is--refreshing': isRefreshing }"
            @click="getRecommendList"
          >
            <span class="val">{{ $t('lang053') }}</span>
          </div>

          <div class="gray-line"></div>

          <nuxt-link
            class="classify__more-btn"
            :to="
              videoInfo && videoInfo.videoType === 1
                ? localePath('/show')
                : localePath('/games')
            "
          >
            <div>
              {{ $t('lang040') }}
            </div>
            <div class="arrow-icon"></div>
          </nuxt-link>
        </div>
      </div>

      <div class="room-recommend-live-list">
        <ul class="clearfix">
          <component
            :is="
              videoInfo && videoInfo.videoType === 1
                ? 'ShowRoomEntrance'
                : 'GameRoomEntrance'
            "
            v-for="(room, index) in recommendList.slice(0, 5)"
            :key="index"
            :room-info="room"
            responsive
          />
        </ul>
      </div>
    </div>

    <login-popup v-model="loginPopUpVisible"></login-popup>

    <!-- 分享复制后的tips -->
    <div v-if="Copied" id="copiedTips_e">
      Copied
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Clipboard from 'clipboard';
import { throttle } from 'throttle-debounce';
import getDeviceId from '@components/Player/deviceId';
import Player from '@components/Player';
import BigoDanMu from '@components/Player/danmu';
import giftAnimation from '@components/Player/giftAnimation';
import Chat from '@components/Chat';
import GameRoomEntrance from '@components/GameRoomEntrance';
import ShowRoomEntrance from '@components/ShowRoomEntrance';
import DisCordBanner from '@components/DisCordBanner';
import PlayerWs from '@components/Player/playerWs';
import LoginPopup from '@components/LoginPopup/index';
import { getCountryCode } from '@assets/js/utils';
import api from '~/services';
import apiChannel from '~/services/channel';

const env = process.env.NUXT_ENV_MODE;
const urlMap = {
  dev: 'https://ta-www.bigo.tv',
  test: 'https://ta-www.bigo.tv',
  gray: 'https://bggray-www.bigo.tv',
  prod: 'https://www.bigo.tv'
};

/* eslint-disable camelcase */

const ignoreUidLength = 50;

export default {
  scrollToTop: true,
  name: 'Room',
  components: {
    Player,
    Chat,
    GameRoomEntrance,
    ShowRoomEntrance,
    LoginPopup,
    DisCordBanner
  },
  async asyncData({ params, store, $log, query }) {
    // 房间页有两个链接，一个是/_bigoid一个是/sid/:sid
    const infoStudioQuery = {};
    if (params.bigoid) {
      infoStudioQuery.bigoId = params.bigoid;
    } else {
      infoStudioQuery.sid = params.sid;
    }
    const asyncData = {
      ignoreUids: [],
      // 主播金豆数，国家码，直播类型
      videoInfo: {
        bean: '-'
      }
    };
    try {
      if (!params.sid && !params.bigoid) {
        $log && $log.error('error', { msg: '!params.sid && !params.bigoid' });
        return asyncData;
      }
      const res = await api.getUserInfoStudio(infoStudioQuery);
      if (res && res.code === 0 && res.data && !Array.isArray(res.data)) {
        asyncData.videoInfo = res.data;
        res.data && store.commit('update_videoType', res.data.videoType);
        asyncData.ignoreUids.push(res.data.uid);
      } else {
        $log &&
          $log.error('request error', { msg: res, api: 'getUserInfoStudio' });
      }
      // 频道房获取封面跟频道名
      if (+query.t === 7) {
        const channel = await apiChannel.getChannelInfo({
          uid: +query.u
        });
        if (channel.code === 0) {
          asyncData.videoInfo.channelBg = channel.data?.cover;
          asyncData.videoInfo.channelName = channel.data?.name;
        }
      }
    } catch (err) {
      console.log(err);
      $log &&
        $log.error('request error', {
          msg: `${err.message}, ${err.stack}`,
          api: 'getUserInfoStudio'
        });
    }
    return asyncData;
  },
  data() {
    this.throttleAdjustDanmuSize = throttle(2000, this.adjustDanmuSize);
    return {
      showPoptip: false,
      current: {},
      playerControlLayout: 'volume,rotate,full-screen',
      ws: null,
      nums: 0,
      beans: 0,
      chatData: [
        {
          type: 'init'
        }
      ],
      liveInfo: {},
      recommendList: [],
      // 是否正在刷新推荐列表
      isRefreshing: false,
      // 登陆popup
      loginPopUpVisible: false,
      isFollowed: false,
      // 展示关注成功的提示
      showFollowSuccess: false,
      // 取消关注时候的提示
      showUnfollowTips: false,
      // 评论内容
      comment: '',
      // PK房有PK遮罩
      showPKCover: false,
      showFollowGuide: false,
      isInTheRoom: false,
      loginRoomRequestTimes: 0,
      theTabUniqueId: 0,
      now: +new Date(),
      // 延时 joinGroup 的定时器 timer
      joinRoomTimer: null,
      clipboardVal: 'https://www.bigo.tv/',
      Copied: false
    };
  },
  computed: {
    avatar() {
      return (
        this.videoInfo.ogImage ||
        'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'
      );
    },
    bigoid() {
      // 访问的是/sid/:sid这个链接的时候，bigoId只能从接口中获取
      return this.$route.params.bigoid || this.videoInfo.bigoId;
    },
    ...mapGetters(['isLogin', 'myBigoId'])
  },
  created() {
    if (process.client) {
      this.getRecommendList();
      this.followGuide();
    }
  },
  mounted() {
    if (window.assetsLoadMonitor) {
      window.assetsLoadMonitor.sendCustomKeyReport({
        type: 'first_screen_time', // 自定义打点类型， type参数不能是page_view_time 和 white_screen_time， 因为会和公共库pv和白屏打点冲突
        extra: {
          // 扩展信息， 业务按需传
          msg: '首屏时间',
          page: '_bigoid'
        }
      });
    }

    document.addEventListener('click', (e) => {
      if (!e.target.className.includes('poptip-dom')) {
        this.showPoptip = false;
      }
    });

    this.current.bigoid = this.bigoid;
    this.startLive(this.bigoid);
    this.$nextTick(() => {
      giftAnimation.giftInit();
    });
    // 给时间让qrcode.js加载完成
    setTimeout(() => {
      this.handlePkRoom();
    }, 3000);

    // 测试动画用
    window.testani = (gift) => {
      giftAnimation.giftAnimationStart(gift);
    };

    window.addEventListener('beforeunload', this.handleClosePage);
  },
  beforeDestroy() {
    this.ws && this.ws.destroy();
    this.handleClosePage();
    window.removeEventListener('storage', this.listenStorageChange);
    window.removeEventListener('focus', this.listenWindowFocus);
    window.removeEventListener('resize', this.throttleAdjustDanmuSize);
    window.removeEventListener('beforeunload', this.handleClosePage);
    window.danmu && clearInterval(window.danmu.danMuIntervalId);

    this.$hive.send('010012006', {
      staytime: +new Date() - this.now,
      passRoom: this.liveInfo.passRoom ? 1 : 0
    });
    this.logoutRoom({ type: 'close' });
  },
  methods: {
    handleOpenMultiCover() {
      this.showPKCover = true;
    },
    handleClosePage() {
      clearTimeout(this.joinRoomTimer);
      this.pageEndReport();
      this.logoutRoom();
    },
    async loginRoom() {
      if (this.isInTheRoom) return;
      // 密码房的密码可能已经保存在 cookie
      // if (this.liveInfo.passRoom && !this.liveInfo.password) {
      //   this.liveInfo.password = getCookie(`${this.bigoid}-psw`);
      // }
      const deviceId = await getDeviceId();
      const res = await this.$api.joinGroup({
        bc_gid: encodeURIComponent(this.liveInfo.roomId),
        // 密码房密码
        secretKey: this.liveInfo.password,
        deviceId
      });
      this.loginRoomRequestTimes += 1;
      if (res.code === 0) {
        this.isInTheRoom = true;
        console.log('join group success');
      } else if (res.code === 700006) {
        // login expired
        await this.$api.logout();
        this.$store.commit('update_userInfo', {});
      } else if (+res.code === 3) {
        console.log('join group fail, try again');
        if (this.loginRoomRequestTimes < 3) {
          this.joinRoomTimer = setTimeout(() => {
            this.loginRoom();
          }, 1000);
        }
      }
    },
    async logoutRoom(e = {}) {
      // 用户主动关闭页面或者收到 localstorage change时调用 leaveGroup
      if (
        (e.type === 'close' && this.isInTheRoom === true) ||
        (e.key === 'logoutRoom' &&
          this.theTabUniqueId !== e.newValue.split('&')[1] &&
          this.isInTheRoom === true)
      ) {
        const res = await this.$api.leaveGroup({
          bc_gid: encodeURIComponent(this.liveInfo.roomId)
        });
        if (+res.code === 0) {
          this.isInTheRoom = false;
          console.log('logout success');
        } else {
          console.log('logout room');
        }
      }
    },
    handlePkRoom() {
      const { roomStatus, passRoom } = this.liveInfo;
      if (+roomStatus === 4 && !passRoom) {
        this.showPKCover = true;
      } else if (+roomStatus === 6) {
        setTimeout(() => {
          this.showPKCover = true;
        }, 60 * 1000);
      }
      try {
        const roomid = this.liveInfo.roomId;
        const uid = this.liveInfo.uid;
        const url = `http://${location.host}/index_wap.html?dl=bigolive://livevideoshow?roomid=${roomid}&uid=${uid}`;
        // eslint-disable-next-line
        new QRCode(document.querySelector('.multi_live_code .code_box'), {
          text: url,
          width: 110,
          height: 110,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.M
        });
      } catch (err) {
        console.error('ORcode init fail', err);
      }
    },
    async send() {
      if (!this.isLogin) {
        this.loginPopUpVisible = true;
      } else {
        if (!this.comment) {
          this.$toast('The content can not be blank!');
          return;
        }
        // 去掉回车换行
        const comment = this.comment.replace(/[\r\n]/g, '');
        const { roomId, uid } = this.liveInfo;
        // 下播的直播间没有 roomId，不执行发送弹幕
        if (!+roomId || !+uid) {
          this.$toast('roomId or anchor uid error');
          return;
        }
        const data = {
          interfaceName: 'sendChat',
          type: 1,
          content: comment,
          bc_gid: this.liveInfo.roomId,
          owner: this.liveInfo.uid
        };
        const res = await this.$api.broadcast(data);
        if (res.code === 0) {
          console.log('评论成功');
          this.comment = '';
          this.$log && this.$log.info('broadcast success');
          return;
        } else if (res.code === 2 || res.code === 81022) {
          // 2 是 3秒内发言多次，房间返回的错误码，81022 是 1秒内发言多次，后台返回的错误码
          this.$toast(
            'Sending failed, speak too frequently, please try again later'
          );
        } else if (res.code === 700001 || res.code === 800021) {
          this.$toast('Please login again');
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          this.$toast(
            'Sending failed, please try again later or send using BIGO LIVE APP'
          );
        }
        this.$log && this.$log.error('broadcast error', { msg: res?.code });
      }
    },
    shareClick(type) {
      const twTitle = document.getElementsByTagName('title')[0].innerHTML;
      const twUrl = window.location.href;

      if (type === 'whatsApp') {
        window.open(
          'https://api.whatsapp.com/send/?phone&app_absent=0&text=' +
            encodeURIComponent(twUrl),
          '_blank'
        );
      } else if (type === 'twitter') {
        window.open(
          'https://www.twitter.com/share/?text=' +
            encodeURIComponent(twTitle) +
            '&url=' +
            encodeURIComponent(twUrl) +
            '&via=BIGOLIVEapp&related=BIGOLIVE',
          '_blank'
        );
      } else if (type === 'pinterest') {
        window.open(
          'https://www.pinterest.com/pin-builder/?url=' +
            encodeURIComponent(twUrl) +
            '&description=' +
            encodeURIComponent(twTitle) +
            '&is_video=true&method=button&media=' +
            encodeURIComponent(
              this.videoInfo.ogImage ||
                'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'
            ),
          '_blank'
        );
      } else if (type === 'reddit') {
        window.open(
          'https://www.reddit.com/submit?title=' +
            encodeURIComponent(twTitle) +
            '&url=' +
            encodeURIComponent(twUrl),
          '_blank'
        );
      } else if (type === 'facebook') {
        window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' +
            encodeURIComponent(twUrl),
          '_blank'
        );
      } else if (type === 'copy') {
        this.clipboardVal = window.location.href;
        const clipboard = new Clipboard('.copylink_btn');

        clipboard.on('success', () => {
          this.Copied = true;
          setTimeout(() => {
            this.Copied = false;
          }, 1000);
        });
      }
    },
    async follow() {
      if (!this.isLogin) {
        this.loginPopUpVisible = true;
      } else {
        if (this.isFollowed) {
          this.showUnfollowTips = true;
          setTimeout(() => {
            this.showUnfollowTips = false;
          }, 2000);
          return;
        }
        const res = await this.$api.follow({
          bc_uid: encodeURIComponent(this.liveInfo.uid)
        });
        if (res && res.code === 0) {
          this.showFollowSuccess = true;
          this.isFollowed = true;

          setTimeout(() => {
            this.showFollowSuccess = false;
          }, 1000);
        } else if (res.code === 700001) {
          this.$toast('Please login again');
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          this.$log && this.$log.error('follow error', { msg: res.code });
        }
      }
    },
    async queryFollow() {
      const res = await this.$api.followQuery({
        bc_uid: encodeURIComponent(this.liveInfo.uid)
      });
      if (res && res.code === 0) {
        // 0 代表myUid关注了uids，1 代表互相关注，2 代表反过来myUid是uids的粉丝，3 代表没有关系
        this.isFollowed = res.data.relation <= 1;
      } else if (res.code === 700001) {
        window.location.reload();
      }
    },
    followGuide() {
      if (localStorage && !localStorage.getItem('firstVisitRoom')) {
        this.showFollowGuide = true;
        localStorage.setItem('firstVisitRoom', 'visited');
      }
    },
    async getRecommendList() {
      if (this.isRefreshing) return;
      this.isRefreshing = true;
      const { videoInfo } = this;
      const { countryCode = 'ALL', videoType } = videoInfo;
      const vType = videoType === 1 ? 5 : 11;
      const api = vType === 5 ? 'getShowbizList' : 'getGamingList';
      const tabType = vType === 5 ? countryCode : '00';
      const gameCountryCode =
        vType === 5 ? undefined : getCountryCode(this.$i18n.locale, true);
      try {
        const res = await this.$api[api]({
          tabType,
          fetchNum: '6',
          ignoreUids: this.ignoreUids.join('.'),
          countryCode: gameCountryCode,
          lang: this.$i18n.locale // 这里 getShowbizList 也会有
        });
        const recommendList = res?.data || [];
        this.isRefreshing = false;
        if (recommendList && recommendList.length > 0) {
          this.recommendList = recommendList;
          this.updateIgnoreUids(recommendList);
        }
      } catch (e) {
        console.error(e);
        this.isRefreshing = false;
      }
    },
    updateIgnoreUids(arr) {
      const uids = arr.map((it) => it.owner);
      if (this.ignoreUids.length > ignoreUidLength) {
        this.ignoreUids = this.ignoreUids.slice(
          this.ignoreUids.length - ignoreUidLength,
          this.ignoreUids.length
        );
      }
      this.ignoreUids.push(...uids);
    },
    listenStorageChange(e) {
      if (e.key === 'logoutRoom') {
        this.logoutRoom(e);
      }
    },
    listenWindowFocus() {
      console.log('focus');
      localStorage &&
        localStorage.setItem(
          'logoutRoom',
          new Date().getTime() + '&' + this.theTabUniqueId
        );
      this.joinRoomTimer = setTimeout(this.loginRoom, 1000);
    },
    // 只有完成进房间操作，才能发送弹幕
    joinRoom() {
      // 该tab的唯一标示
      this.theTabUniqueId =
        '' + new Date().getTime() + Math.floor(Math.random() * 10000);
      // 修改local，触发其他tab退房，带上发消息的那个tab的标示
      localStorage &&
        localStorage.setItem(
          'logoutRoom',
          new Date().getTime() + '&' + this.theTabUniqueId
        );
      // 监听local的退房消息
      window.addEventListener('storage', this.listenStorageChange);
      window.addEventListener('focus', this.listenWindowFocus);
    },
    endLive({ liveInfo }) {
      this.liveInfo = liveInfo;
      this.createQrcode();
    },
    finishInitLive({ liveInfo, ws }) {
      this.liveInfo = liveInfo;
      this.ws = ws;
      this.ignoreUids.push(liveInfo.uid);

      if (!process.client) return;

      this.createQrcode();
      if (liveInfo.alive === 1) {
        this.initChat();
      }

      this.$nextTick(() => {
        this.$hive.initHive(this);
        this.$hive.send('010012002', {
          staytime: +new Date() - this.now
        });

        if (!liveInfo.alive) {
          this.$hive.send('010012005', {
            staytime: +new Date() - this.now
          });
        }
      });

      this.joinRoomTimer = setTimeout(() => {
        if (this.isLogin) {
          this.loginRoom();
          this.joinRoom();
        }
      }, 500);

      if (this.isLogin) {
        this.queryFollow();
      }
    },
    createQrcode() {
      const { roomStatus } = this.videoInfo;
      const roomid = this.liveInfo.roomId;
      const uid = this.liveInfo.uid;
      const url = `http://${location.host}/index_wap.html?dl=bigolive://${
        +roomStatus === 1 ? 'themelivevideoshow' : 'livevideoshow'
      }?roomid=${roomid}&uid=${uid}`;
      try {
        // eslint-disable-next-line
        new QRCode(document.querySelector('.qr-code-box'), {
          text: url,
          width: 110,
          height: 110,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.M
        });
      } catch (err) {
        console.error('ORcode init fail');
      }
    },
    startLive(bigoid) {
      this.$refs.player.startLive({
        app: 'bigo',
        siteid: bigoid
      });
    },
    initChat() {
      this.subWs(this.ws);
    },
    updateChatData(item) {
      if (this.chatData.length > 50) {
        this.chatData.shift();
      }
      this.chatData.push({
        time: new Date().getTime(),
        ...item
      });
    },
    adjustDanmuSize() {
      window.danmu && window.danmu.adjustDanMuWidthHeight();
    },
    subWs(ws) {
      const danmu = new BigoDanMu();

      if (process.client) {
        window.danmu = danmu;
        window.addEventListener('resize', this.throttleAdjustDanmuSize);
      }

      danmu.danMuIntervalId = setInterval(() => danmu.drawDanMu(), 40);

      ws.sub(PlayerWs.EVENT.NUMS, (msg) => {
        // 观众人数更新
        if (`${this.liveInfo.roomId}` === msg.gid) {
          this.nums = msg.totalUserCount;
        } else {
          PlayerWs.log('roomid不对，bigo观众数不更新');
        }
      });

      ws.sub(11032, (msg) => {
        // bigo观众数主动拉取更新
        if (`${this.liveInfo.roomId}` === msg.room_id) {
          this.nums = msg.total;
        } else {
          PlayerWs.log('roomid不对，bigo观众数主动拉取不更新');
        }
      });

      ws.sub(3608, (msg) => {
        // roomStatus; 0->正在直播，1->正常退出，2->封退, 3->暂时离开, 4->回来, 5->表示告警封退
        if (msg.roomStatus === '4') {
          this.updateChatData({
            type: PlayerWs.CHAT_EVENT.ROOM_OWNER_BACK_TEXT,
            m: 'Broadcaster is back. LIVE is recovering'
          });
        } else if (msg.roomStatus === '3') {
          this.updateChatData({
            type: PlayerWs.CHAT_EVENT.ROOM_OWNER_LEAVE_TEXT,
            m: 'Broadcaster will leave for a moment. Please hold on'
          });
        } else if (msg.roomStatus === '1') {
          this.$hive.send('010012005', {
            staytime: +new Date() - this.now
          });
        }
      });

      ws.sub(PlayerWs.EVENT.NORMAL_TEXT, (msg) => {
        if (this.liveInfo.roomId === msg.room_id) {
          const type = +msg.payload.tag;
          const oriUri = msg.oriUri;
          const roomId = msg?.payload?.room_id;
          let content = '';
          try {
            if (msg.payload.content) {
              content = JSON.parse(
                decodeURIComponent(escape(window.atob(msg.payload.content)))
              );
              // 公屏
              this.updateChatData({
                type,
                grade: msg.payload?.grade,
                ...content
              });
            }
            // 弹幕
            switch (type) {
              case PlayerWs.CHAT_EVENT.NORMAL_TEXT:
                danmu.readyArguments(content.m);
                break;
              case PlayerWs.CHAT_EVENT.DAMMARKU_TEXT:
                danmu.appendPayDanMu(content.n, content.m);
                break;
            }
            // 用户送礼
            if (oriUri === '760969' && this.liveInfo.roomId === roomId) {
              giftAnimation.giftAnimationStart(msg.payload);
              this.videoInfo.bean = msg.payload.ticket_num;
            }
          } catch (e) {
            console.log(msg.payload.content);
            PlayerWs.log('公屏消息显示失败', e);
          }
        } else {
          PlayerWs.log('roomid不对，评论不更新');
        }
      });
    },
    pageEndReport() {
      this.$hive.send('010012006', {
        staytime: +new Date() - this.now,
        passRoom: this.liveInfo.passRoom ? 1 : 0
      });
    }
  },
  head({ $route }) {
    const {
      nickname,
      ogImage,
      aliOSUrl,
      keywords,
      channelBg,
      channelName
    } = this.videoInfo;
    const alive = true; // 目前写死的
    const {
      params,
      query: { c, p, t, b, uid }
    } = $route;
    let alWebUrl = '';
    if (params.bigoid) {
      alWebUrl = `${urlMap[env]}/${escape(params.bigoid)}`;
    } else if (params.sid) {
      alWebUrl = `${urlMap[env]}/sid/${escape(
        params.sid
      )}?c=${c}&p=${p}&t=${t}&b=${b}&uid=${uid}`;
    }

    const title = `[001] - BIGO LIVE`.replace(
      /\[001\]/g,
      channelName || nickname || this.bigoid
    );
    const description = this.$t('lang335');

    const title2 = this.$t('lang336').replace(
      /\[001\]/g,
      channelName || nickname || this.bigoid
    );
    const description2 = this.$t('lang184').replace(
      /\[001\]/g,
      channelName || nickname || this.bigoid
    );

    const today = new Date().getTime();
    const tomorrow = today + 86400 * 1000;
    const yesterday = today - 86400 * 1000;
    let startDate = yesterday;
    let endDate = yesterday;
    if (alive) {
      startDate = yesterday;
      endDate = tomorrow;
    }
    // https://developers.google.com/search/docs/advanced/structured-data/video?hl=zh-cn#video-object
    const StructuredData = {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      description: description2,
      name: title2,
      thumbnailUrl: [
        // 支持 JPEG、PNG，尺寸：最小 60x30 像素（尽可能使用大尺寸图片）
        ogImage ||
          'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'
      ],
      uploadDate: new Date(today).toISOString(),

      embedUrl: alWebUrl, // TODO
      author: nickname,

      publication: [
        {
          '@type': 'BroadcastEvent',
          isLiveBroadcast: true,
          startDate: new Date(startDate).toISOString(),
          endDate: new Date(endDate).toISOString()
        }
      ]
    };

    return {
      title: title2,
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: title2
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description2
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: keywords
        },
        // al
        {
          hid: 'al:ios:url',
          property: 'al:ios:url',
          content: aliOSUrl
        },
        {
          hid: 'al:android:url',
          property: 'al:android:url',
          content: aliOSUrl
        },
        {
          hid: 'al:web:url',
          property: 'al:web:url',
          content: alWebUrl
        },
        // og
        {
          hid: 'og:image',
          property: 'og:image',
          content:
            channelBg ||
            ogImage ||
            'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: alWebUrl
        },
        // twitter: https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/abouts-cards
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content:
            channelBg ||
            ogImage ||
            'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content: alWebUrl
        }
      ],
      script: [
        {
          hid: 'structured-data',
          type: 'application/ld+json',
          innerHTML: JSON.stringify(StructuredData)
        }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      __dangerouslyDisableSanitizersByTagID: {
        // description: ['content'],
        // title: ['content'],
        // 'og:image': ['content'],
        // 'al:web:url': ['content'],
        // 'al:ios:url': ['content'],
        // 'al:android:url': ['content'],
        // 'og:description': ['content']
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.room {
  max-width: 1340px;
  margin: 20px auto;

  .room-container {
    width: 100%;
    position: relative;
    display: flex;

    .room-container__left {
      width: 989px;

      .room-host-about {
        width: 100%;
        height: 96px;
        background: #fff;
        position: relative;
        z-index: 10;
        border-radius: 4px;
        padding: 20px;

        &::after {
          content: '';
          display: block;
          clear: both;
        }

        .host-avatar {
          width: 56px;
          height: 56px;
          margin-right: 8px;
          overflow: hidden;
          border-radius: 50%;
          transform: translateY(-50%);
          position: relative;
          top: 50%;
          float: left;
        }

        .host-center {
          // margin-left: 100px;
          // margin-right: 200px;
          transform: translateY(-40%);
          position: relative;
          top: 50%;

          .host-nickname {
            font-size: 18px;
            font-weight: 500;
            color: #2f3033;
            line-height: 21px;
            margin-bottom: 9px;
          }

          .host-info {
            font-size: 14px;
            font-weight: 400;
            color: #8a8f99;
            line-height: 16px;

            .info-bigoId,
            .info-bean,
            .info-view-nums,
            .info-location {
              display: inline-block;
            }

            .info-bean,
            .info-view-nums,
            .info-location {
              position: relative;
              margin-left: 30px;

              &::before {
                width: 14px;
                height: 14px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                content: '';
                position: absolute;
                left: -19px;
                top: 1px;
              }
            }

            // .info-bigoId {
            //   color: #999;
            // }

            // .line {
            //   display: inline-block;
            //   font-size: 14px;
            //   color: #e2e2e2;
            //   margin-left: 15px;
            //   line-height: 25px;
            // }

            .info-bean {
              &::before {
                background-image: url(~assets/img/bean.png);
              }
            }

            .info-view-nums {
              &::before {
                background-image: url(~assets/img/people.png);
              }
            }

            .info-location {
              &::before {
                background-image: url(~assets/img/location.png);
              }
            }
          }
        }

        .host-share-btn {
          float: right;
          position: relative;
          top: -40px;
          padding-right: 10px;
          padding-left: 28px;
          cursor: pointer;
          // min-width: 79px;
          height: 28px;
          border-radius: 24px;
          border: 1px solid #c4c7cc;
          font-size: 14px;
          font-weight: 600;
          color: #2f3033;
          line-height: 16px;
          display: flex;
          justify-items: center;
          align-items: center;

          &::before {
            display: block;
            content: '';
            width: 14px;
            height: 14px;
            position: absolute;
            left: 10px;
            top: 5.5px;
            z-index: 8;
            background-position: center center;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url('~@/assets/img/share.png');
          }
        }

        .host-follow {
          float: right;
          position: relative;
          top: -40px;
          // min-width: 81px;
          height: 28px;
          margin-left: 10px;

          .host-follow-btn {
            height: 100%;
            border-radius: 24px;
            background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
            padding-right: 10px;
            padding-left: 28px;
            font-size: 14px;
            font-weight: 600;
            color: #ffffff;
            line-height: 17px;
            cursor: pointer;
            display: flex;
            justify-items: center;
            align-items: center;
            position: relative;

            &::before {
              display: block;
              content: '';
              position: absolute;
              left: 10px;
              top: 8px;
              z-index: 8;
              width: 12px;
              height: 12px;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: cover;
              background-image: url('~@/assets/mobile/images/add_follow_btn_ic@2x.png');
            }

            &.followed {
              background: #fff;
              border: 1px solid #c4c7cc;
              color: #2f3033;
              padding-left: 14px;

              &::before {
                background-image: none;
              }
            }
          }

          .follow_guide {
            position: absolute;
            z-index: 8;
            width: 511px;
            height: 215px;
            right: -407px;
            top: -35px;
            background: url(~@assets/img/tips_follow.png) center no-repeat;

            .follow_guide_btn {
              position: absolute;
              width: 30px;
              height: 30px;
              cursor: pointer;
              right: 0px;
              top: 33px;
            }
          }
        }

        .host-follow-success {
          position: absolute;
          z-index: 8;
          width: 272px;
          height: 122px;
          left: -170px;
          top: 35px;
          display: block;
          background: url('~@/assets/img/tips_following.png') center no-repeat;
        }

        .host-unfollow-tips {
          position: absolute;
          z-index: 8;
          width: 240px;
          height: 203px;
          left: -100px;
          top: -37px;
          background: url('~@/assets/img/tips_unfollow.png') center no-repeat;

          .host-unfollow-link {
            display: block;
            width: 110px;
            height: 30px;
            background: #0dc;
            line-height: 30px;
            text-align: center;
            border-radius: 3px;
            margin: 150px auto 0;
            color: #fff;
            font-size: 14px;
          }
        }

        .guide-phone {
          position: absolute;
          right: 20px;
          top: 61px;

          .guide-phone-title {
            position: relative;
            font-size: 14px;
            font-weight: 400;
            color: #8a8f99;
            line-height: 20px;

            &::before {
              display: inline-block;
              content: '';
              position: absolute;
              left: -20px;
              top: 3px;
              width: 14px;
              height: 14px;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: cover;
              background-image: url('~@/assets/img/scan.png');
            }
          }

          &:hover .scan-qr-code {
            display: block;
            animation: scale 0.5s;
          }

          .scan-qr-code {
            position: absolute;
            //margin-top: 29px;
            z-index: 10;
            padding: 0 10px 20px;
            right: -22px;
            top: 28px;
            width: 347px;
            border-bottom-left-radius: 3px;
            border-bottom-right-radius: 3px;
            display: none;
            transform-origin: 100% 0;
            background: #fff;
            border: 1px #e2e2e2 solid;

            &::before {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              display: block;
              content: '';
              background: #00ddcc;
              height: 2px;
            }

            &::after {
              position: absolute;
              top: 0;
              left: 70%;
              transform: translate(0, -100%);
              display: block;
              content: '';
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 0 5.5px 5px 5.5px;
              border-color: transparent transparent #00ddcb transparent;
            }

            &-desc {
              margin-top: 10px;
              text-align: center;
              color: #2e2e2e;
              font-size: 12px;
              line-height: 35px;
              position: relative;
              background: #fff;
            }

            &-steps {
              margin-top: 10px;
              line-height: 14px;

              .step {
                &-title {
                  margin: 0 auto;
                  width: 80%;
                  font-size: 12px;
                  color: #666666;
                }

                &-img {
                  display: inline-block;
                }
              }

              .qr-code-box {
                display: inline-block;
                position: relative;

                &::after {
                  width: 134px;
                  height: 134px;
                  background: url('~@/assets/img/code-bg.png') center no-repeat;
                  background-size: 100% 100%;
                  position: absolute;
                  display: block;
                  content: '';
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                }
              }
            }

            &-note {
              margin-top: 10px;
              font-size: 12px;
              text-align: center;
              width: 100%;
              background: #fff;
              color: #8ba8b4;
            }
          }
        }
      }

      .room-video {
        position: relative;
        margin-top: 12px;
      }
    }

    .room-container__right {
      width: 340px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      padding-bottom: 58px;
      border-radius: 4px;

      .user_sent_msg {
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 52px;
        border-radius: 4px;
        // border-top: 1px #e2e2e2 solid;
      }

      .user_words_msg textarea {
        width: 250px;
        height: 45px;
        border: none;
        padding: 10px 10px 0;
        font-size: 14px;
        color: #000;
      }
      .user_words_msg .login_tips {
        position: absolute;
        left: 0;
        top: 0;
        width: 250px;
        height: 100%;
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #c4c7cc;
        line-height: 52px;
      }
      .user_words_msg ::-webkit-input-placeholder {
        color: #e2e2e2;
        font-size: 14px;
      }
      .user_words_msg :-moz-placeholder {
        color: #e2e2e2;
        font-size: 14px;
      }
      .user_words_msg ::-moz-placeholder {
        color: #e2e2e2;
        font-size: 14px;
      }
      .user_words_msg :-ms-input-placeholder {
        color: #e2e2e2;
        font-size: 14px;
      }
      .user_words_msg .login_tips a {
        color: #00decb;
        margin-left: 12px;
      }

      .user_words_msg .send_btn {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto 12px;
        cursor: pointer;
        width: 70px;
        height: 28px;
        background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
        border-radius: 24px;
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
        line-height: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .room-recommend-live {
    margin-top: 60px;

    .room-recommend-live__header {
      margin-bottom: 14px;
      position: relative;

      .header-title {
        float: left;
        font-size: 28px;
        font-weight: 600;
        color: #2f3033;
        line-height: 40px;

        // &::before {
        //   content: '';
        //   float: left;
        //   width: 32px;
        //   height: 30px;
        //   vertical-align: middle;
        //   background: url('~@/assets/img/icon.png') -4px -458px no-repeat;
        // }

        // .val {
        //   display: inline-block;
        //   vertical-align: middle;
        // }
      }

      .header-right {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .header-change {
          cursor: pointer;
          font-size: 13px;
          font-weight: 400;
          color: #8a8f99;
          line-height: 40px;
          position: relative;

          @keyframes rotate-round {
            0% {
              transform: rotate(0deg);
            }

            50% {
              transform: rotate(180deg);
            }

            100% {
              transform: rotate(360deg);
            }
          }

          &.is--refreshing::before {
            animation: rotate-round 2s linear infinite;
          }

          &::before {
            content: '';
            width: 20px;
            height: 20px;
            vertical-align: middle;
            background: url('~@/assets/img/icon.png') -1px -842px no-repeat;
            position: absolute;
            left: -20px;
            top: 0;
            bottom: 0;
            margin: auto 0;
          }

          .val {
            display: inline-block;
            vertical-align: middle;
          }
        }

        .gray-line {
          width: 1px;
          height: 12px;
          background: #8a8f99;
          border-radius: 1px;
          position: relative;
          margin: 0 10px;
        }

        .classify__more-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          font-weight: 400;
          color: #8a8f99;
          line-height: 16px;

          .arrow-icon {
            width: 12px;
            height: 12px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            background-image: url('~@/assets/img/right_arrow.png');
          }
        }
      }
    }

    .room-recommend-live-list {
      // overflow: hidden;
      margin-right: -25px;
      // height: 300px;
    }
  }
}

.pk_live_box {
  position: absolute;
  z-index: 9;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(~@assets/img/pk_live_bg.jpg) center no-repeat;
  background-size: cover;

  .close_btn {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    border: 1px #fff solid;
    cursor: pointer;

    &::before {
      font-family: 'iconFont';
      color: #fff;
      content: '\e904';
      display: block;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
    }
  }

  .multi_live_cont {
    width: 570px;
    height: 390px;
    position: absolute;
    left: 50%;
    margin-left: -285px;
    top: 47%;
    margin-top: -195px;
  }

  .multi_live_tips {
    width: 100%;
    margin: 0 auto 10px;
    text-align: center;
    font-size: 24px;
    color: #00ffee;
    line-height: 150%;
  }

  .multi_live_code {
    width: 397px;
    height: 305px;
    background: url('~@assets/img/multi_live_cov.png') center no-repeat;
    background-size: 100% 100%;
    margin: auto;
    position: relative;
  }
  .multi_live_code .code_box {
    position: absolute;
    right: 38px;
    top: 133px;
    width: 115px;
    height: 115px;
    border: 2px #fff solid;
  }
  .multi_live_download {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: -70px;
    width: 397px;
    overflow: hidden;
  }
  .multi_live_download span {
    font-size: 20px;
    color: #fff;
  }
  .multi_live_download a {
    width: 125px;
    height: 30px;
    display: block;
    float: right;
    font-size: 16px;
    color: #161616;
    background: #0dc;
    border-radius: 3px;
    text-align: center;
    line-height: 30px;
  }
}

@keyframes scale {
  0% {
    transform: scale(0.8);
  }

  25% {
    transform: scale(1.1);
  }

  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

.bounceIn {
  animation-duration: calc(var(--animate-duration) * 0.75);
  animation-name: bounceIn;
}

.poptip-animation-enter-active {
  animation: bounceIn 1s;
}

.poptip {
  position: absolute;
  color: #a50000;
  font-size: 20px;
  line-height: 30px;
  width: 300px;
  padding: 20px;
  padding-bottom: 5px;
  z-index: 100;
  bottom: -265px;
  right: -100px;
  background-color: #fff;
  border: 1px solid rgb(128, 128, 138);
  border-top: 2px solid #00ddcb;
  box-shadow: 0 3px 8px 2px rgba(1, 1, 1, 0.2);
  border-radius: 8px 6px;
  color: #000;
  font-weight: 500;

  .share-link {
    position: relative;
    padding-left: 44px;
    margin-bottom: 15px;

    &::before {
      display: block;
      content: '';
      width: 30px;
      height: 30px;
      position: absolute;
      left: 0;
      top: 0;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    &.share-WhatsApp {
      &::before {
        background-image: url('~@/assets/mobile/images/share_whatsapp.png');
      }
    }

    &.share-Twitter {
      &::before {
        background-image: url('~@/assets/mobile/images/share_twitter.png');
      }
    }

    &.share-Pinterest {
      &::before {
        background-image: url('~@/assets/mobile/images/share_pinterest.png');
      }
    }

    &.share-Reddit {
      &::before {
        background-image: url('~@/assets/mobile/images/share_reddit.png');
      }
    }

    &.share-Facebook {
      &::before {
        background-image: url('~@/assets/mobile/images/share_facebook.png');
      }
    }

    &.share-Copy {
      &::before {
        background-image: url('~@/assets/mobile/images/share_copylink.png');
      }
    }
  }

  &::after {
    position: absolute;
    top: 0;
    left: 10%;
    transform: translate(0, -100%);
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #00ddcb transparent;
  }

  a {
    display: block;
  }
}

#copiedTips_e {
  position: fixed;
  z-index: 99999;
  left: 50%;
  margin-left: -35px;
  top: 50%;
  width: 98px;
  height: 42px;
  background: #000;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 42px;
  border-radius: 5px;
}
</style>
